import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import OutboundVirtualTerminals from "./Components/OutboundVirtualTerminals";
import { useTranslation } from "react-i18next";

/**
 * @namespace OutboundVirtualTerminalsPage
 */

const OutboundVirtualTerminalsPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [
      { label: t("title.catalogs") },
      { label: t("title.outboundVirtualTerminals") },
    ];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <OutboundVirtualTerminals />
    </>
  );
};

export default OutboundVirtualTerminalsPage;
